import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Alert, message, Progress } from "antd";
import { isEmpty } from "lodash";
import Input from "../../Components/Common Components/Input/Input";
import Button from "../../Components/Common Components/Button/Button";
import authService from "../../Services/authService";
import { formatLoginData } from "../Utilities/Utils";
import supplycologo from "../../Assets/Icons/supplyco-logo.png";
const Login = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isprogress, setProgress] = useState(false);
  const [isFormError, setFormError] = useState(false);
  const [strFormType, setFormType] = useState();
  const [strMessage, setMessage] = useState();
  const navigate = useNavigate();
  const [messageApi, messageContextHolder] = message.useMessage();

  const onSubmit = async (data) => {
    setProgress(true);
    try {
      const formattedData = formatLoginData(data);
      const methodName = "bm.auth.login";
      const response = await authService.userLogin(formattedData, methodName);
      const result = response?.data?.tables?.result[0];

      if (result?.type === "-1") {
        setFormError(true);
        setFormType("error");
        setMessage(result?.message || "Wrong username or password");
      } else if (result?.type === "1") {
        const sessionId = response?.data?.tables?.login_session[0]?.id;

        const existingSessionId = localStorage.getItem("sessionId");
        if (existingSessionId) {
          localStorage.removeItem("sessionId");
        }
        localStorage.setItem("sessionId", sessionId);
        const empId = response?.data?.tables?.parameter[0]?.emp_id;
        localStorage.setItem("emp_id", empId);
        const allPermissions = response?.data?.tables?.user_permission; // your response object
        const permissionsArray = Object.values(allPermissions || {});
        const filteredPermissions = permissionsArray.filter(
          (p) => p.permission === "6" || p.permission === "8"
        );
        console.log("authData", filteredPermissions);
        // Store filtered permissions in localStorage
        localStorage.setItem(
          "userPermissions",
          JSON.stringify(filteredPermissions)
        );

        setFormError(false);
        message.open({
          type: "success",
          content: "Logged In Sucessfully.",
        });
        navigate("/taxList");
      } else {
        // Unexpected response
        setFormError(true);
        setFormType("error");
        setMessage("Unexpected response from server");
      }
    } catch (error) {
      console.error("API request failed:", error);
      setFormError(true);
      setFormType("error");
      setMessage(error.message || "Network error occurred");
    } finally {
      setProgress(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-100">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center">
          <img src={supplycologo} alt="logo" />
        </div>
        <div className="mt-5 mb-5 bg-white border-0 shadow-lg">
          <p className="p-4 text-2xl font-bold text-center text-gray-800">
            Sign In
          </p>
          {/* <p className="text-sm text-center text-gray-600">
            Enter your credentials to access the approver dashboard
          </p> */}
          <div className="flex items-center justify-center w-full p-4">
            <div className="w-full">
              {isFormError && (
                <Alert
                  message="Whoops!"
                  type={strFormType}
                  description={strMessage}
                  style={{ width: "90%", margin: "auto" }}
                />
              )}
              <form
                className="flex flex-col w-full mb-10 customForm"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="flex w-full ">
                  <div className="flex flex-col w-full px-8">
                    <div className="flex flex-row w-full">
                      <div className="w-full">
                        <Input
                          type="username"
                          name="party_username"
                          label="Username"
                          placeholder="Enter Your Username"
                          control={control}
                          rules={{
                            required: "This field is required",
                          }}
                          className="h-12"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full px-8">
                  <Input
                    type="password"
                    name="party_password"
                    label="Password"
                    placeholder="Enter Your Password"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    className="h-12"
                  />
                </div>

                <div className="mx-8">
                  <button
                    className="inline-flex items-center justify-center w-full h-10 px-4 py-2 text-sm font-medium text-white transition-colors bg-blue-600 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-blue-700"
                    type="submit"
                  >
                    LOGIN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
